import https from 'https';
import http from 'http';

export const promiseRequest = async (options: https.RequestOptions, requestFn: (request: http.ClientRequest) => void = () => { }): Promise<string> => {
  return new Promise((resolve, reject) => {
    const req = https.request(options, function (res) {
      const chunks: Uint8Array[] = []

      res.on('data', function (chunk) {
        chunks.push(chunk)
      })

      res.on('end', function () {
        const body = Buffer.concat(chunks)
        resolve(body.toString())
      })

      res.on('error', function (error) {
        reject(error)
      })
    })

    requestFn(req)

    req.end()
  })
}